import { render, staticRenderFns } from "./profileMobile.vue?vue&type=template&id=1d09b07c"
import script from "./profileMobile.vue?vue&type=script&lang=js"
export * from "./profileMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports